<ng-container>
    <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
    <button mat-raised-button color="primary" (click)="fileUpload.click()">{{this.field.label}}</button>
    <p>{{this.fileName}}</p>
    <a *ngIf="this.uploadedFile" target="_blank" [href]="this.uploadedFile">Uploaded file</a>
</ng-container>